import { Route, Routes } from "react-router-dom";

// Admin dashboard login
import {
  Login,
  ForgetPassword,
  ResetPassword,
  Dashboard,
  ListSession,
  CreateSession,
  ListExercise,
  CreateExercise,
  ViewExercise,
  EditExercise,
  ViewSession,
  EditSession,
  AssignFormatFirst,
  AssignFormatSecond,
  ListGym,
  CreateGym,
  CreateNewFormat,
  FormatList,
  EditFormat,
  EditAssignFormatSecond,
  CreateNewFormatEdit,
  ScheduleGym,
  EditGym,
} from "../pages";
import UnprotectedRoute from "../pages/UnprotectedRoute";
import ProtectedRoute from "../pages/ProtectedRoute";

export const adminRoutes = {
  dashboard: "/",
  login: "/login",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password",
  listSession: "/list-session",
  createSession: "/add-session",
  viewSession: "/view-session/:sessionId",
  editSession: "/edit-session/:sessionId",
  listFormat: "/list-format/:sessionId",
  assignFormatFirst: "/assign-format-first/:sessionId",
  assignFormatSecond: "/assign-format-second/:sessionId",
  createFormat: "/add-format",
  editFormat: "/edit-format/:formatId",
  editAssignFormatSecond: "/edit-assign-format-second/:formatId",
  editCreateNewFormatEdit: "/edit-add-format/:formatId",
  listExercise: "/list-exercise",
  createExercise: "/add-exercise",
  viewExercise: "/view-exercise/:exerciseId",
  editExercise: "/edit-exercise/:exerciseId",
  listGym: "/list-gym",
  createGym: "/add-gym",
  scheduleGym: "/gym-schedule/:gymId",
  editGym: "/edit-gym/:gymId",
};

const AdminRouter = () => {
  return (
    <Routes>
      <Route element={<UnprotectedRoute />}>
        <Route path={adminRoutes.login} element={<Login />} />
        <Route path={adminRoutes.forgetPassword} element={<ForgetPassword />} />
      </Route>

      <Route element={<ProtectedRoute />}>
      <Route path={adminRoutes.resetPassword} element={<ResetPassword />} />
        <Route path={adminRoutes.dashboard} element={<Dashboard />} />
        <Route path={adminRoutes.listSession} element={<ListSession />} />
        <Route path={adminRoutes.createSession} element={<CreateSession />} />
        <Route path={adminRoutes.viewSession} element={<ViewSession />} />
        <Route
          path={adminRoutes.assignFormatFirst}
          element={<AssignFormatFirst />}
        />
        <Route
          path={adminRoutes.assignFormatSecond}
          element={<AssignFormatSecond />}
        />
        <Route path={adminRoutes.editSession} element={<EditSession />} />
        <Route path={adminRoutes.listExercise} element={<ListExercise />} />
        <Route path={adminRoutes.createExercise} element={<CreateExercise />} />
        <Route path={adminRoutes.viewExercise} element={<ViewExercise />} />
        <Route path={adminRoutes.editExercise} element={<EditExercise />} />
        <Route path={adminRoutes.createFormat} element={<CreateNewFormat />} />
        <Route path={adminRoutes.listFormat} element={<FormatList />} />
        <Route path={adminRoutes.editFormat} element={<EditFormat />} />
        <Route
          path={adminRoutes.editAssignFormatSecond}
          element={<EditAssignFormatSecond />}
        />
        <Route
          path={adminRoutes.editCreateNewFormatEdit}
          element={<CreateNewFormatEdit />}
        />
        <Route path={adminRoutes.listGym} element={<ListGym />} />
        <Route path={adminRoutes.createGym} element={<CreateGym />} />
        <Route path={adminRoutes.scheduleGym} element={<ScheduleGym />} />
        <Route path={adminRoutes.editGym} element={<EditGym/>} />
      </Route>
    </Routes>
  );
};

export default AdminRouter;
